import { useEffect, useRef, useState } from "react";
import { formRules, roleNames } from "../../constant";
import { Modal, Typography, Form, Input, Checkbox, Space, Radio, DatePicker } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";
import Add from "./Add";
import { useApiCall } from "../../services/api";
import ApplyProductModal from "./ApplyProductModal";
import { useSelector } from "react-redux";
import { handleRouteNav } from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const AddSchemeModal = ({
  isOpen,
  closeModal,
  schemeData,
  title = "Add Scheme",
  btnText = "Add Scheme",
  isEdit = false,
  copyScheme = false,
  handleSubmit,
}) => {
  const [form] = Form.useForm();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isProductModal, setProductModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const { postApi, loading } = useApiCall();
  const [isModalOpen, setIsModalOpen] = useState(isOpen);
  const { user_id, role_id, full_name } = useSelector((state) => state.auth);
  const [selectedproductIds, setSelectedproductIds] = useState([]);
  const navigate = useNavigate();
  const { showPopup } = useGlobalModal();
  const location = useLocation();
  const pathname = location.pathname;

  const formContainerId = "scheme-modal-container";

  useEffect(() => {
    if (isModalOpen) {
      const values = form.getFieldValue("variants");

      if (!values || values.length === 0) {
        form.setFieldsValue({
          variants: [{ variant_qty: "", variant_incentive: "" }],
        });
      }

      setTimeout(() => {
        const modalContainer = document.getElementById(formContainerId);
        const antModalWrap = modalContainer?.closest(".ant-modal-wrap");

        if (antModalWrap) {
          antModalWrap.scrollTop = 0;
        } else if (modalContainer) {
          modalContainer.scrollTop = 0;
        }
      }, 50);
    }
  }, [isModalOpen, form]);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (isModalOpen) {
      const values = form.getFieldValue("variants");

      if (!values || values.length === 0) {
        form.setFieldsValue({
          variants: [{ variant_qty: "", variant_incentive: "" }],
        });
      }
    }
  }, [isModalOpen]);

  const handleFinish = async (values) => {
    if (selectedproductIds.length === 0) {
      return showPopup({
        title: null,
        content: <span className="custom-modal-title">Please select at least one product.</span>,
        onOk: () => console.log("OK"),
        className: "custom-success-modal",
      });
    } else if (!values.qty_type) {
      return showPopup({
        title: null,
        content: <span className="custom-modal-title">Quantity type is required.</span>,
        onOk: () => console.log("OK"),
        className: "custom-success-modal",
      });
    } else if (!values.credit_type) {
      return showPopup({
        title: null,
        content: <span className="custom-modal-title">Credit type is required.</span>,
        onOk: () => console.log("OK"),
        className: "custom-success-modal",
      });
    }

    const payload = {
      remarks: values.remarks?.trim() || "",
      from_date: values.from_date.format("YYYY-MM-DD"),
      to_date: values.to_date.format("YYYY-MM-DD"),
      title: values.title,
      credit_type: values.credit_type || "",
      qty_type: values.qty_type || "",
      variants:
        values.variants?.map((item) => ({
          ...item,
          variant_qty: Number(item.variant_qty),
          variant_incentive: Number(item.variant_incentive).toFixed(2),
        })) || [],
      sort_nos: selectedproductIds.map((item) => Number(item)),
      customer_ids: [],
      user_ids: [],
      updated_by_id: user_id,
      updated_by: full_name,
      offer_id: isEdit && !copyScheme ? schemeData?.offer_id : undefined,
    };
    try {
      const response = await postApi(
        isEdit && !copyScheme ? "sales/offer/update" : "sales/offer/add",
        payload,
        true,
      );
      if (!response?.status) {
        return;
      }
      setIsModalOpen(false);
      closeModal();
      handleSubmit?.();
      resetEntireForm();
      const targetPath = handleRouteNav("/discount-schemes", role_id);
      if (isEdit) {
        // navigate(handleRouteNav(`/scheme-details`, role_id), {
        //   state: {
        //     refresh: Date.now(),
        //     mode: true,
        //     offerId: schemeData?.offer_id,
        //   },
        // });
      } else if (pathname !== targetPath) {
        navigate(targetPath, {
          state: { refresh: Date.now() },
        });
      }
    } catch (error) {}
  };

  const fetchProducts = async () => {
    try {
      const response = await postApi("product", {});
      if (!response?.status) {
        setProductData([]);
        return;
      }
      setProductData(response.data || []);
    } catch (error) {
    } finally {
    }
  };

  const getSelectedProducts = (products) => {
    setSelectedproductIds(products.map((item) => Number(item)));
    setSelectedProducts(productData.filter((item) => products.includes(item.sort_no)));
    setProductModal(false);
    setIsModalOpen(true);
  };

  const resetEntireForm = () => {
    form.resetFields();

    form.setFieldsValue({
      variants: [{ variant_qty: "", variant_incentive: "" }],
    });

    setSelectedProducts([]);
    setSelectedproductIds([]);
  };

  useEffect(() => {
    fetchProducts();

    // if (!isEdit && !copyScheme) {
    //   resetEntireForm();
    // }
  }, []);

  useEffect(() => {
    if (schemeData && (isEdit || copyScheme)) {
      form.setFieldsValue({
        title: schemeData?.title,
        from_date: schemeData?.from_date ? dayjs(schemeData?.from_date) : null,
        to_date: schemeData?.to_date ? dayjs(schemeData?.to_date) : null,
        qty_type: schemeData?.qty_type || "",
        credit_type:
          schemeData?.credit_type == "Percentage" ? "percentage" : schemeData?.credit_type,
        remarks: schemeData?.remarks || "",
        variants:
          schemeData?.variants?.length > 0
            ? schemeData.variants.map((variant) => ({
                variant_qty: variant.variant_qty,
                variant_incentive: Number(variant.variant_incentive),
                variant_id: variant.variant_id || "",
              }))
            : [{ variant_qty: "", variant_incentive: "", variant_id: "" }],
      });
      setSelectedProducts(schemeData?.product_details || []);
      setSelectedproductIds(schemeData?.product_details?.map((item) => item.sort_no) || []);
    }
  }, [schemeData, isOpen, isEdit, copyScheme]);

  // Helper function to block "e", "E", "+", and "-" keys
  const blockInvalidNumberChars = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Modal
        open={!!isModalOpen}
        title={
          <Title level={2} className="font-abhaya !mb-0">
            {title}
          </Title>
        }
        onCancel={() => {
          closeModal();
          setIsModalOpen(false);
        }}
        width={400}
        footer={null}
        className="form-css-5"
      >
        <div id={formContainerId}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleFinish}
            requiredMark={false}
            className="mt-8"
          >
            {/* Scheme Name */}
            <Form.Item
              label="Scheme Name"
              name="title"
              rules={formRules.required}
              validateTrigger="onBlur"
            >
              <Input placeholder="Enter scheme name" />
            </Form.Item>

            {/* Date Range */}
            <div className="grid grid-cols-2 gap-3">
              <Form.Item
                label="From"
                name="from_date"
                rules={formRules.required}
                validateTrigger="onBlur"
              >
                <DatePicker
                  disabledDate={(current) => {
                    const toDate = form.getFieldValue("to_date");

                    return current && toDate && current > toDate.endOf("day");
                  }}
                />
              </Form.Item>

              <Form.Item
                label="To"
                name="to_date"
                rules={formRules.required}
                validateTrigger="onBlur"
              >
                <DatePicker
                  disabledDate={(current) => {
                    const fromDate = form.getFieldValue("from_date");

                    return current && fromDate && current < fromDate.startOf("day");
                  }}
                />
              </Form.Item>
            </div>

            {/* Apply Products */}
            <div>
              <Text>Apply Products</Text>
              <div className="border flex justify-between items-center mt-2 mb-4 p-2 rounded-md">
                <div className="flex gap-1 items-center">
                  <>
                    <div>
                      {selectedProducts.slice(0, 1).map((product) => (
                        <div key={product?.sort_no}>
                          <Text>{product?.short_name}</Text>
                        </div>
                      ))}
                    </div>
                    {selectedProducts?.length > 1 && (
                      <Text
                        className="cursor-pointer font-bold"
                        onClick={() => {
                          setProductModal(true);
                          setIsModalOpen(false);
                        }}
                      >
                        +{selectedProducts.length - 1} more
                      </Text>
                    )}
                  </>
                </div>
                <div
                  className="cursor-pointer text-[#A33434] font-bold"
                  onClick={() => {
                    setProductModal(true);
                    setIsModalOpen(false);
                  }}
                >
                  Select
                </div>
              </div>
            </div>

            {/* Discount Info */}
            <div className="p-3 rounded-md mb-8 mt-8 text-center text-md font-bold bg-[#FBEEEC]">
              Discount Information
            </div>

            {/* Quantity Type */}
            <Form.Item label="Quantity type" name="qty_type" layout="horizontal">
              <Radio.Group
                max={1} // ⭐ Allow only ONE selection
              >
                <Space>
                  <Radio value="Meter">Mtrs</Radio>
                  <Radio value="Cases">Cases</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item label="Credit type" name="credit_type" layout="horizontal">
              <Radio.Group max={1}>
                <Space>
                  <Radio value="Rs/mtr">Rs. / Mtr</Radio>
                  <Radio value="percentage">Percentage</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.List name="variants">
              {(fields, { add, remove }, { getFieldValue }) => (
                <>
                  {fields.map((field, index) => (
                    <div key={field.key} className="mb-3 relative">
                      {/* Header */}
                      <div className="flex justify-between items-center mb-2">
                        <Text strong>Slab {index + 1}</Text>

                        {fields.length > 1 && (
                          <Text
                            className="cursor-pointer text-[#A33434] font-bold"
                            onClick={() => {
                              remove(field.name);
                              setTimeout(() => {
                                const currentVariants = form.getFieldValue("variants") || [];
                                const qtyPaths = currentVariants.map((_, i) => [
                                  "variants",
                                  i,
                                  "variant_qty",
                                ]);
                                form.validateFields(qtyPaths).catch(() => {});
                              }, 0);
                            }}
                          >
                            - Remove
                          </Text>
                        )}
                      </div>

                      {/* Quantity */}
                      <Form.Item
                        {...field}
                        label="Quantity - Mtrs or Cases"
                        name={[field.name, "variant_qty"]}
                        validateTrigger="onBlur"
                        rules={[
                          { required: true, message: "Quantity must be a whole number ≥ 1" },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value) return Promise.resolve();

                              const strVal = String(value);
                              const numVal = Number(value);

                              if (strVal.includes(".") || numVal < 1) {
                                return Promise.reject(
                                  new Error("Quantity must be a whole number ≥ 1"),
                                );
                              }

                              if (index === 0) return Promise.resolve();

                              const prevValue = getFieldValue([
                                "variants",
                                index - 1,
                                "variant_qty",
                              ]);

                              if (!prevValue || numVal > Number(prevValue)) {
                                return Promise.resolve();
                              }

                              return Promise.reject(
                                new Error("Quantity must be greater than previous slab."),
                              );
                            },
                          }),
                        ]}
                      >
                        <Input
                          className="no-spinner"
                          type="number"
                          onKeyDown={blockInvalidNumberChars}
                          placeholder="Enter quantity - Mtrs or Cases"
                        />
                      </Form.Item>

                      {/* Incentive */}
                      <Form.Item
                        {...field}
                        label="Incentive - Rs. / Mtr or %"
                        name={[field.name, "variant_incentive"]}
                        validateTrigger="onBlur"
                        rules={[
                          { required: true, message: "Incentive must be a number > 0" },
                          // ✅ Added validator for Incentive ≥ 1
                          () => ({
                            validator(_, value) {
                              if (!value && value !== 0) return Promise.resolve();
                              if (Number(value) <= 0) {
                                return Promise.reject(new Error("Incentive must be a number > 0"));
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          className="no-spinner"
                          type="number"
                          placeholder="Enter Incentive - Rs. / Mtr or %"
                          onKeyDown={blockInvalidNumberChars}
                          step="any"
                        />
                      </Form.Item>
                    </div>
                  ))}

                  {/* Add Button */}
                  <div className="text-right">
                    {fields.length > 0 && (
                      <Text
                        className="cursor-pointer font-bold text-[#A33434]"
                        onClick={() => {
                          const lastIndex = fields.length - 1;

                          form
                            .validateFields([
                              ["variants", lastIndex, "variant_qty"],
                              ["variants", lastIndex, "variant_incentive"],
                            ])
                            .then(() => {
                              add();
                            })
                            .catch(() => {
                              // If invalid, do nothing (Ant Design automatically shows the red errors)
                            });
                        }}
                      >
                        + Add More
                      </Text>
                    )}
                  </div>
                </>
              )}
            </Form.List>

            {/* Special Remarks */}
            <Form.Item label="Special Remarks" name="remarks">
              <Input.TextArea rows={3} />
            </Form.Item>

            {/* Submit Button */}
            <div className="w-full flex justify-center mt-4">
              <PrimaryButton
                text={btnText}
                type="submit"
                htmlType="submit"
                loading={loading}
                className="me-[30px]"
              />
            </div>
          </Form>
        </div>
      </Modal>

      <ApplyProductModal
        handleSubmit={getSelectedProducts}
        selectedproduct={selectedProducts}
        productData={productData}
        open={isProductModal}
        onClose={() => {
          setProductModal(false);
          setIsModalOpen(true);
        }}
      />
    </>
  );
};

export default AddSchemeModal;
